// extracted by mini-css-extract-plugin
export default {"matchLine":"oNUcd","subtext":"jIbeZ"};